export default {
  activeActivity: (state, getters) => {
    if (getters['featureToggles/canUseNewChangeSlideMechanism']) {
      return state.slideV2
    }
    return state.slide
  },
}
